/**
 * Offers API — list, get, create, update, approve, reject, delete.
 */

import { apiFetch } from './core'

/** Публичные вызовы по токену (без JWT). Пути без завершающего слэша — см. core.js */
export const offerSigning = {
    get: (token) => apiFetch(`/offers/signing/${encodeURIComponent(token)}`),
    accept: (token) => apiFetch(`/offers/signing/${encodeURIComponent(token)}/accept`, { method: 'POST', body: '{}' }),
    decline: (token) => apiFetch(`/offers/signing/${encodeURIComponent(token)}/decline`, { method: 'POST', body: '{}' }),
}

export const offers = {
    list: (params = {}) => {
        const qs = new URLSearchParams(params).toString()
        return apiFetch(`/offers/${qs ? `?${qs}` : ''}`)
    },
    get: (id) => apiFetch(`/offers/${id}`),
    getContext: (candidateId, vacancyId) => apiFetch(`/offers/context/${candidateId}/${vacancyId}`),
    generate: (data) => apiFetch('/offers/generate', {
        method: 'POST',
        body: JSON.stringify(data),
    }),
    preview: (id) => apiFetch(`/offers/preview/${id}`),
    approveDraft: (id, approvedBy = 'admin') => apiFetch(`/offers/${id}/approve`, {
        method: 'POST',
        body: JSON.stringify({ approved_by: approvedBy }),
    }),
    send: (id) => apiFetch(`/offers/${id}/send`, { method: 'POST' }),
    recordResponse: (id, accepted) => apiFetch(`/offers/${id}/response`, {
        method: 'POST',
        body: JSON.stringify({ accepted }),
    }),
    acceptAndStartProbation: (id, applicationId = null) => apiFetch(`/offers/${id}/accept-and-start-probation`, {
        method: 'POST',
        body: JSON.stringify({ application_id: applicationId }),
    }),
    create: (data) => apiFetch('/offers', {
        method: 'POST',
        body: JSON.stringify(data),
    }),
    update: (id, data) => apiFetch(`/offers/${id}`, {
        method: 'PATCH',
        body: JSON.stringify(data),
    }),
    approve: (id) => apiFetch(`/offers/${id}/approve`, { method: 'POST' }),
    reject: (id, reason = '') => apiFetch(`/offers/${id}/reject?reason=${encodeURIComponent(reason)}`, { method: 'POST' }),
    delete: (id) => apiFetch(`/offers/${id}`, { method: 'DELETE' }),
    importExternal: (items, dryRun = true) => apiFetch('/offers/import-external', {
        method: 'POST',
        body: JSON.stringify({ items, dry_run: dryRun }),
    }),
    /** Строки-кандидаты из YouGile/OnlyOffice (source: 'yougile' | 'onlyoffice'). Ничего не записывает. */
    discoverExternal: (source) => apiFetch('/offers/import-external/discover', {
        method: 'POST',
        body: JSON.stringify({ source }),
    }),
    /** Комната ONLYOFFICE DocSpace с офферами: { connected, folder_id }. */
    getOnlyOfficeRoom: () => apiFetch('/offers/import-external/onlyoffice-room'),
    setOnlyOfficeRoom: (folderId) => apiFetch('/offers/import-external/onlyoffice-room', {
        method: 'PUT',
        body: JSON.stringify({ folder_id: folderId }),
    }),
}
